import { cva } from 'class-variance-authority';

export const statusChip = cva(
  'text-color-text-dark border-color-grey-dark bg-color-background-base text-size-body3 inline-flex min-h-2 flex-row justify-center rounded-full border px-1 [&>*>[class^="icon-emp"]]:size-[12px]',
  {
    variants: {
      color: {
        error: 'text-color-error-dark border-color-error-dark bg-color-error-light',
        info: 'text-color-info-dark border-color-info-dark bg-color-info-light',
        primary: 'text-color-primary-dark border-color-primary-dark bg-color-primary-light',
        secondary: 'text-color-secondary-dark border-color-secondary-dark bg-color-secondary-light',
        success: 'text-color-success-dark border-color-success-dark bg-color-success-light',
        warning: 'text-color-warning-dark border-color-warning-dark bg-color-warning-light',
      },
    },
  },
);
